export default __webpack_public_path__ + "static/penn-wu-9fe069bcb9b9010bfe15cb2a1ac9b178.jpeg";